<section class="terms">
  <div class="terms-inner">
    <h1 class="terms-title">Terms &amp; Conditions</h1>

    <p class="terms-updated">
      <strong>Last Updated:</strong> January 2026
      <span class="muted">· v{{ build.version }}</span>
    </p>

    <div class="terms-card">
      <p class="terms-intro">
        Welcome to <strong>Project Brendan</strong>. By using this application, you agree to the
        Terms &amp; Conditions below. If you do not agree, please do not use the application.
      </p>

      <h2 class="terms-heading">1) Educational and Simulated Trading Only</h2>
      <p class="terms-text">
        <strong><em><u>Project Brendan is a simulated trading and research platform intended for educational,
        informational, and demonstration purposes only.</u></em></strong> Any strategies, signals, analytics, or
        outputs generated by this application are not financial advice and should not be relied
        upon to make real-world trading decisions.
      </p>

      <h2 class="terms-heading">2) No Financial, Investment, or Legal Advice</h2>
      <p class="terms-text">
        Project Brendan does not provide investment, financial, tax, legal, or accounting advice.
        You are solely responsible for your own decisions. If you require professional advice,
        you should consult a qualified professional.
      </p>

      <h2 class="terms-heading">3) Risk Disclosure</h2>
      <p class="terms-text">
        Trading and investing involve risk and can result in substantial losses, including the
        loss of your entire investment. Past performance is not indicative of future results.
        Markets are volatile and unpredictable.
      </p>

      <h2 class="terms-heading">4) No Liability for Losses</h2>
      <p class="terms-text">
        To the maximum extent permitted by law, Project Brendan and its creators, contributors,
        and affiliates are not liable for any direct, indirect, incidental, special, consequential,
        or punitive damages, including but not limited to financial losses, trading losses, loss
        of profits, loss of data, or business interruption arising from or related to your use of
        the application.
      </p>

      <h2 class="terms-heading">5) Accuracy and Availability</h2>
      <p class="terms-text">
        While we aim to provide useful and accurate information, the application may contain
        errors, omissions, delays, or inaccuracies. Features may change or be removed at any time.
        The application is provided on an “as-is” and “as-available” basis without warranties of
        any kind.
      </p>

      <h2 class="terms-heading">6) User Responsibility</h2>
      <p class="terms-text">
        You are responsible for verifying any information produced by the application and for
        understanding the risks of trading. You agree not to use Project Brendan for unlawful
        purposes or in any way that could damage, disable, overburden, or impair the application.
      </p>

      <h2 class="terms-heading">7) Data and Telemetry (Optional)</h2>
      <p class="terms-text">
        Project Brendan may collect limited technical telemetry to improve reliability and user
        experience, such as navigation events, error diagnostics, and performance metrics. We do
        not intentionally collect sensitive personal information for simulated trading use.
      </p>

      <h2 class="terms-heading">8) Updates to These Terms</h2>
      <p class="terms-text">
        We may update these Terms &amp; Conditions from time to time. Continued use of the
        application after changes are posted constitutes acceptance of the updated terms.
      </p>

      <hr class="terms-divider" />

      <p class="terms-acceptance">
        By clicking <strong>Accept</strong>, you acknowledge that you have read and understood
        these Terms &amp; Conditions and agree to be bound by them.
      </p>

     <div class="terms-confirm">
  <p class="terms-label">
    To continue, type (case-sensitive) <strong><u>{{ challenge }}</u></strong> below:
  </p>

  <mat-form-field appearance="outline" class="terms-field">
        <mat-label>Confirmation</mat-label>
        <input
          matInput
          id="acceptText"
          name="acceptText"
          type="text"
          [(ngModel)]="acceptText"
          [ngModelOptions]="{ standalone: true }"
          autocomplete="off"
          autocapitalize="off"
          autocorrect="off"
          spellcheck="false"
        />
        @if (!canAccept) {
          <mat-hint>
            The Accept button will be enabled once the phrase matches.
          </mat-hint>
        }
        </mat-form-field>
      </div>
      <div class="terms-actions">
        <button type="button" class="btn-secondary" (click)="decline()">
          Decline
        </button>

        <button type="button" 
          class="btn-primary" 
          (click)="accept()" 
          [disabled]="!canAccept"
          [attr.aria-disabled]="!canAccept"
          [attr.disabled]="!canAccept ? '' : null">
          Accept
        </button>
      </div>
    </div>
  </div>
</section>
